export default "__VITE_ASSET__DRzdfK$w__"